let confirmAlertPromise: Promise<(options: any) => void> | null = null;

async function getConfirmAlert(): Promise<(options: any) => void> {
  if (!confirmAlertPromise) {
    confirmAlertPromise = import('react-confirm-alert').then((mod: any) => mod.confirmAlert);
  }
  return confirmAlertPromise;
}

export function confirmAlert(options: any): void {
  void getConfirmAlert().then((fn) => {
    fn(options);
  });
}
